import { ButtonIcon, Tooltip, TooltipTrigger } from '@backstage/ui';
import { RiRefreshLine } from '@remixicon/react';

export interface ButtonIconScanProps {
  variant: 'tertiary' | 'primary' | 'secondary';
  size: 'small' | 'medium';
  /**
   * Icon color, e.g. a CSS variable or hex value.
   */
  color?: string;
  isDisabled?: boolean;
  onClick: () => void;
}

export const ButtonIconScan = (props: ButtonIconScanProps) => {
  const { variant, size, color, isDisabled, onClick } = props;
  return (
    <TooltipTrigger delay={100}>
      <ButtonIcon
        icon={<RiRefreshLine />}
        variant={variant}
        size={size}
        style={color ? { color } : undefined}
        onClick={onClick}
        isDisabled={isDisabled ?? false}
      />
      <Tooltip placement="bottom">Scan</Tooltip>
    </TooltipTrigger>
  );
};
